import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pathgen } from 'object-path-generator';
import { Column, Typography } from 'seagull';
import SignedAgreementAnimationWrapper from '../SignedAgreementAnimationWrapper/SignedAgreementAnimationWrapper';
import styles from './RelationshipSignedWithAnimations.module.scss';
export const RelationshipApprovedWithAnimationsDataTestIds = pathgen('RelationshipApprovedWithAnimationsDataTestIds');
const RelationshipApprovedWithAnimations = ()=>/*#__PURE__*/ _jsx(SignedAgreementAnimationWrapper, {
        testId: RelationshipApprovedWithAnimationsDataTestIds.Root(),
        children: /*#__PURE__*/ _jsx(Column, {
            className: styles.thankYouSectionWrapper,
            children: /*#__PURE__*/ _jsxs(Column, {
                className: styles.thankYouSection,
                testId: RelationshipApprovedWithAnimationsDataTestIds.ThankYouSection(),
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h3",
                        weight: "normal",
                        children: "Thanks for signing!"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        children: "You will receive a confirmation email shortly."
                    })
                ]
            })
        })
    });
export default RelationshipApprovedWithAnimations;
